/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '../../molecules/accordion/accordion';
import Table from '../../molecules/table/table';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import FormSelect from '../../molecules/formSelect/formSelect';
import FormCheckbox from '../../molecules/formCheckbox/formCheckbox';
import FormInputText from '../../molecules/formInputText/formInputText';
import FormExternalResource from '../../molecules/formExternalResource/formExternalResource';
import FormDatePicker from '../../molecules/formDatePicker/formDatePicker';
import FormUploadAsync from '../../molecules/formUploadAsync/formUploadAsync';
import FormLoadFromCatalog from '../../molecules/formLoadFromCatalog/formLoadFromCatalog';
import FormShowText from '../../molecules/formShowText/formShowText';
import { storeStructure } from '../../../store/reducers';
import FormValidation from '../../atoms/formEnums/formValidation';
import FormRelationship from '../formRelationship/formRelationship';
import FormTextEditor from '../../molecules/formTextEditor/formTextEditor';
import FormInputRelationship from '../formInputRelationship/formInputRelationship';
import FormMultipleUploadAsync from '../../molecules/formMultipleUploadAsync/formMultipleUploadAsync';
import TextScroll from '../../atoms/textScroll/textScroll';
import Button, { ButtonSize, ButtonTheme, ButtonType } from '../../atoms/button/button';

const FormGroupExpansion = (props) => {
  const {
    name,
    value,
    id,
    match,
    configFile,
    config,
    onChange,
    onCreateWithRefresh,
    onChangeItemPosition,
    onDelete,
    onUpload,
    onCompletedUploadFiles,
    onCanceledUploadFiles,
    onClickNewItem,
    session
  } = props;
  const errorState = useSelector((state) => state[storeStructure.Errors]);
  const [values, setValues] = useState([]);
  const buildPayload = (data) => {
    if (configFile?.isObjectWrapper) {
      return {
        [configFile.attributeName]: data,
      };
    }

    return data;
  };
  const handlerOnChange = (event, attributeName, objIndex) => {
    const newValues = [...values];
    newValues[objIndex] = {
      ...newValues[objIndex],
      [attributeName]: event.target.value,
    };

    setValues(newValues);
    onChange(buildPayload(newValues));
  };

  const handlerFormButton = (newDataObject, attributeName) => {
    onChange({ [attributeName]: newDataObject.id });
  };

  const handlerOnTableCreate = (newRow, attributeName) => {
    const field = configFile.fields.find((x) => x.attributeName === attributeName);
    const newTableRow = field.configFile.fields
      .reduce((acumulator, x) => ({ ...acumulator, [x.attributeName]: x.default }), {});
    const newTableValue = value[attributeName] ? [...value[attributeName], { ...newTableRow, ...newRow }] : [{ ...newTableRow, ...newRow }];
    if (configFile.refreshUpdate) onCreateWithRefresh({ [attributeName]: newTableValue });
    else handlerOnChange({ target: { value: newTableValue } }, attributeName);
  };

  const handlerOnTableDelete = (deleteRow, attributeName) => {
    const formFieldValues = value[attributeName];
    const indexOfDeleteRow = formFieldValues.indexOf(deleteRow);
    formFieldValues.splice(indexOfDeleteRow, 1);
    handlerOnChange({ target: { value: formFieldValues } }, attributeName);
  };


  const handlerOnInputRelationshipTableDelete = (deleteRow, attributeName) => {
    // onDeleteInputRelationship(deleteRow, attributeName);
  };

  const handleAccordionDuplication = () => {
    if (configFile.default) {
      onClickNewItem(values.concat(configFile.default));
    } else {
      setValues(values.concat({}))
    }
  };

  const handleAccordionRemoval = (deleteRow) => {
    const selectedRow = values.filter((item, index) => index == deleteRow);
    if (selectedRow && selectedRow[0] && selectedRow[0].id && selectedRow[0][configFile.parentId]) {
      onDelete(selectedRow[0].id, config.removeURL, selectedRow[0][configFile.parentId]);
    }
  };
  useEffect(() => {
    if (!value) {
      setValues([]);
      return;
    }

    if (configFile?.isObjectWrapper) {
      const wrappedValue = value?.[configFile.attributeName];
      setValues(Array.isArray(wrappedValue) ? wrappedValue : []);
      return;
    }

    setValues(Object.values(value))
  }, [value, configFile]);
  const isVisible = (field, formGroupValue) => {
    let isVisible = true
    if (field.visibleWhen && Array.isArray(field.visibleWhen)) {
      field.visibleWhen.forEach((elArr) => {
        if (formGroupValue && elArr.value == "bool-false") {
          if (formGroupValue[elArr.field] == true) {
            isVisible = false;
          }
        } else if (formGroupValue && elArr.value && elArr.value != "bool-false" && elArr.value && elArr.value != "not-null" && (formGroupValue[elArr.field] === undefined || formGroupValue[elArr.field] != elArr.value)) {
          isVisible = false;
        } else if (formGroupValue && elArr.value == "not-null") {
          if (formGroupValue[elArr.field] == 0 || formGroupValue[elArr.field] == "" || formGroupValue[elArr.field] == undefined) {
            isVisible = false;
          }
        } else if (formGroupValue && elArr.notValue) {
          if (formGroupValue[elArr.field] == undefined || formGroupValue[elArr.field] == elArr.notValue) {
            isVisible = false;
          }
        }
      });
    }
    return isVisible;
  }

  return (
    <div className='formGroup__expansion'>
      {values.map((formGroup, index) => (
        <Accordion id={id} key={index} title={configFile.title} helpText={configFile.helpText} canDuplicate onClickRemove={() => handleAccordionRemoval(index)}>
          {configFile.fields.map((field, i) => {
            let out;
            if (isVisible(field, formGroup)) {
              switch (field.type) {
                case FormInputTypes.TABLE:
                  out = (
                    <Table
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      dataSet={formGroup[field.attributeName] === undefined ? [] : formGroup[field.attributeName]}
                      columnSet={field.configFile.fields}
                      label={field.label}
                      canEdit={field.configFile.canEdit}
                      canRemove={field.configFile.canRemove}
                      onChange={(event) => handlerOnChange({ target: { formGroup: event } }, field.attributeName, index)}
                      canOpen={field.configFile.canOpen}
                      canCreate={field.configFile.canCreate}
                      onClickEdit={field.configFile.handleClickEdit}
                      onClickCreate={(event) => handlerOnTableCreate(event, field.attributeName)}
                      onClickRemove={(event) => handlerOnTableDelete(event, field.attributeName)}
                      onClickRemoveInputRelationship={(event) => handlerOnInputRelationshipTableDelete(event, field.attributeName)}
                      emptyMessage={field.configFile.emptyMessage}
                      isSelectable={field.configFile.isSelectable}
                      isMultiSelectable={field.configFile.isMultiSelectable}
                      canChangePosition={field.configFile.canChangePosition}
                      sortingPositionIndex={field.configFile.sortingPositionIndex}
                      onChangePosition={onChangeItemPosition}
                    />
                  );
                  break;
                case FormInputTypes.SELECT:
                  out = (
                    <FormSelect
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      value={formGroup && formGroup[field.attributeName] ? formGroup[field.attributeName] : ''}
                      helpText={field.helpText}
                      options={field.options}
                      asyncSelect={field.asyncSelect}
                      placeholder={field.placeholder}
                      url={field.url}
                      session={session}
                      filter={field.filter}
                      multiple={field.multiple}
                      onChange={(event) => handlerOnChange(event, field.attributeName, index)}
                      emptyValue={field.emptyValue}
                    />
                  );
                  break;
                case FormInputTypes.COLOR_PICKER:
                  out = (
                    <FormSelect
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      value={formGroup[field.attributeName] ? formGroup[field.attributeName] : ''}
                      helpText={field.helpText}
                      options={field.options}
                      multiple={field.multiple}
                      onChange={(event) => handlerOnChange(event, field.attributeName, index)}
                    />
                  );
                  break;
                case FormInputTypes.CHECKBOX:
                  out = (
                    <FormCheckbox
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      helpText={field.helpText}
                      checked={formGroup ? formGroup[field.attributeName] : false}
                      onChange={(event) => handlerOnChange(event, field.attributeName, index)}
                    />
                  );
                  break;
                case FormInputTypes.DOWNLOADABLE:
                case FormInputTypes.BACKGROUND:
                  out = (
                    <FormExternalResource
                      id={`${id}-${field.attributeName}`}
                      type={field.type}
                      key={field.attributeName + i}
                      label={field.label}
                      helpText={field.helpText}
                      value={formGroup ? formGroup[field.attributeName] : ''}
                      onChange={(data) => handlerFormButton(data, field.attributeName, index)}
                    />
                  );
                  break;
                case FormInputTypes.UPLOAD_ASYNC:
                  out = (
                    <FormUploadAsync
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      helpText={field.helpText}
                      fileType={field.fileType}
                      value={formGroup ? formGroup[field.attributeName] : ''}
                      onUpload={(data) => handlerOnChange(data, field.attributeName)}
                      onCompleted={(data) => handlerOnChange(data, field.attributeName, index)}
                    />
                  );
                  break;
                case FormInputTypes.MULTIPLE_UPLOAD_ASYNC:
                  out = (
                    <FormMultipleUploadAsync
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      helpText={field.helpText}
                      fileType={field.fileType}
                      defaultInputValue={field.defaultInputValue}
                      value={formGroup ? formGroup[field.attributeName] : []}
                      onChange={(data) => handlerOnChange(data, field.attributeName, index)}
                      onUpload={onUpload}
                      onCompleted={onCompletedUploadFiles}
                      onCanceled={onCanceledUploadFiles}
                    />
                  );
                  break;
                case FormInputTypes.DATE:
                case FormInputTypes.DATE_TIME:

                  out = (
                    <FormDatePicker
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      value={formGroup[field.attributeName] ? formGroup[field.attributeName] : field.default}
                      onChange={(data) => handlerOnChange(data, field.attributeName, index)}
                      helpText={field.helpText}
                    />
                  );
                  break;
                case FormInputTypes.OTHER_RESOURCE:
                  out = (
                    <FormLoadFromCatalog
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      configFile={field.fromCatalog}
                      helpText={field.helpText}
                      onClose={(data) => handlerOnChange(data, field.attributeName, index)}
                    />
                  );
                  break;
                case FormInputTypes.TEXT:
                  out = (
                    <FormShowText
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      helpText={field.helpText}
                      value={formGroup ? formGroup[field.attributeName] : ''}
                    />
                  );
                  break;
                case FormInputTypes.TEXT_SCROLL:
                  out = (
                    <TextScroll
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      helpText={field.helpText}
                      value={formGroup ? formGroup[field.attributeName] : ''}
                    />
                  );
                  break;
                case FormInputTypes.RELATIONSHIP:
                  out = (
                    <FormRelationship
                      isForm
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      label={field.label}
                      helpText={field.helpText}
                      configFile={field.configFile}
                      value={formGroup[field.attributeName]}
                      onChange={(data) => handlerOnChange(data, field.attributeName, index)}
                    />
                  );
                  break;
                case FormInputTypes.TEXT_EDITOR:
                  out = (
                    <FormTextEditor
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      name={field.label}
                      label={field.label}
                      value={formGroup ? formGroup[field.attributeName] : ''}
                      helpText={field.helpText}
                      validation={errorState[field.attributeName] === undefined
                        ? FormValidation.PENDING : FormValidation.ERROR}
                      onChange={(data) => handlerOnChange(data, field.attributeName, index)}
                    />
                  );
                  break;
                case FormInputTypes.TEXT_OR_RELATIONSHIP:
                  out = (
                    <FormInputRelationship
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      name={field.label}
                      label={field.label}
                      
                      value={formGroup ? formGroup[field.attributeName] : ''}
                      helpText={field.helpText}
                      validation={errorState[field.attributeName] === undefined
                        ? FormValidation.PENDING : FormValidation.ERROR}
                      onChange={(data) => handlerOnChange(data, field.attributeName, index)}
                    />
                  );
                  break;
                default:
                  out = (
                    <FormInputText
                      id={`${id}-${field.attributeName}`}
                      key={field.attributeName + i}
                      name={field.label}
                      placeholder={field.placeholder}
                      helpText={field.helpText}
                      type={field.type}
                      value={formGroup ? formGroup[field.attributeName] : ''}
                      label={field.label}
                      multiple={field.multiple}
                      configFile={field.fromCatalog}
                      configFileComposeExperience={field.fromComposeExperience}
                      onChange={(event) => handlerOnChange(event, field.attributeName, index)}
                      validation={errorState[field.attributeName] === undefined
                        ? FormValidation.PENDING : FormValidation.ERROR}
                      errorText={errorState[field.attributeName] === undefined
                        ? '' : errorState[field.attributeName][0]}
                      defaultValue={field.default === undefined ? '' : field.default}
                      pattern={field.pattern}
                      hidden={field.hidden}
                    />
                  );
              }
            }
            return out;
          })}
        </Accordion>
      ))}
      <Button id={id + '-duplicate'} type={ButtonType.BUTTON} onClick={handleAccordionDuplication} theme={ButtonTheme.PRIMARY} size={ButtonSize.MEDIUM}>
        +
      </Button>
    </div>
  );
};

FormGroupExpansion.propTypes = {
  /**
   * Value store on redux to edit inside the form
   */
  value: PropTypes.shape({}),
  /**
   * Config file
   */
  configFile: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  onChangeItemPosition: PropTypes.func,
  onCreateWithRefresh: PropTypes.func,
  onUpload: PropTypes.func,
  onCompletedUploadFiles: PropTypes.func,
  onCanceledUploadFiles: PropTypes.func,
  onClickNewItem: PropTypes.func,
};

FormGroupExpansion.defaultProps = {
  value: undefined,
  onChange: () => { },
  onDelete: () => { },
  onCreateWithRefresh: () => { },
  onChangeItemPosition: () => { },
  onUpload: () => { },
  onCompletedUploadFiles: () => { },
  onCanceledUploadFiles: () => { },
  onClickNewItem: () => { },
};

export default FormGroupExpansion;
